export const breakpoints = {
    'sm': 600,
    'md': 900,
    'lg': 1200,
    'xl': 1600,
    'xxl': 2000,
}